import ConfirmDialog from '@/commons/confirm-dialog/ConfirmDialog';
import { Iconic } from '@/commons/iconic';
import { ActionsProps } from '@/components/Table/types/actions';
import { PATH_DASHBOARD } from '@/routes/paths';
import { deletePlan } from '@/services/plans';
import { Button, MenuItem } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { translates } from '@/utils';
import { ModalChangeStatusReservation } from '../components/modal/changeStatus';


export const ListActionsReservation = ({
  value,
  openConfirm,
  setOpenConfirm,
  setOpenPopover,
}: ActionsProps) => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateDelete } = useMutation({
    mutationFn: deletePlan,
    mutationKey: ['reservations'],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
  });
  const [statusModal, setStatusModal] = useState(false);
  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleCloseModalStatus = () => {
    setStatusModal(false);
    handleClosePopover();
  };
  const handleOpenModalStatus = () => {
    setStatusModal(true);
  };
  const onDeleteRow = async () => {
    await mutateDelete(value);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <MenuItem
        onClick={() => {
          handleOpenConfirm();
          handleClosePopover();
        }}
        sx={{ color: 'error.main' }}
      >
        <Iconic icon="eva:trash-2-outline" />
        {translates.delete}
      </MenuItem>

      <MenuItem
        onClick={() => {
          handleOpenModalStatus();
        }}
      >
        <Iconic icon="eva:edit-fill" />
        Cambiar
      </MenuItem>

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title={translates.delete}
        content="Are you sure want to delete?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              onDeleteRow();
              handleClosePopover();
            }}
          >
            {translates.delete}
          </Button>
        }
      />
      <ModalChangeStatusReservation
        id={value}
        handleClose={handleCloseModalStatus}
        isOpen={statusModal}
      />
    </>
  );
};
